import Box from '@/common/components/Box'
import ResumeItem from '@/common/components/ResumeItem'
import { formatCurrency } from '@/common/utils/formatters'
import { DeleteEntryProductCategoryModal } from '@/features/privateCompanies/pages/CompanyGovernmentAllocations/Update/components/DeleteEntryProductCategoryModal'
import { UpdateEntryProductCategoryModal } from '@/features/privateCompanies/pages/CompanyGovernmentAllocations/Update/components/UpdateEntryProductCategoryModal'
import { ControlledByType } from '@/features/privateCompanies/types/companyGovernmentAllocation.type'
import { CompanyGovernmentAllocationEntryProductCategory } from '@/features/privateCompanies/types/companyGovernmentAllocationEntry.type'
import { BoxesIcon, FileBoxIcon } from 'lucide-react'
import { EntryGovernmentAllocationDetailsQuantity } from './EntryGovernmentAllocationDetailsQuantity'

interface EntryGovernmentAllocationDetailsProps {
  companyBranchId?: string
  governmentAllocationId: string
  entryProductCategories: CompanyGovernmentAllocationEntryProductCategory[]
  disabled: boolean
  hideButtons?: boolean
  controlledBy?: ControlledByType
  governmentAllocationCurrencyRestricted: boolean | undefined;
}

export const EntryGovernmentAllocationDetails = ({
  companyBranchId,
  governmentAllocationId,
  entryProductCategories,
  disabled,
  hideButtons,
  controlledBy = 'currency',
  governmentAllocationCurrencyRestricted,
}: EntryGovernmentAllocationDetailsProps) => {
  if (controlledBy === 'quantity') {
    return (
      <EntryGovernmentAllocationDetailsQuantity
        companyBranchId={companyBranchId}
        governmentAllocationId={governmentAllocationId}
        entryProductCategories={entryProductCategories}
        disabled={disabled}
        hideButtons={hideButtons}
        governmentAllocationCurrencyRestricted={governmentAllocationCurrencyRestricted}
      />
    )
  }

  return (
    <div className="flex flex-col gap-4">
      {entryProductCategories.map((entryProductCategory) => (
        <Box className="flex flex-col gap-3 p-4" key={entryProductCategory.id}>
          <div className="flex items-center justify-between">
            <div className="flex items-center gap-x-6">
              <div className="flex items-center gap-x-2 text-white-800">
                <BoxesIcon strokeWidth={1} />

                <p>{entryProductCategory.product_category.display_name}</p>
              </div>

              <ResumeItem
                label="Valor limite"
                value={formatCurrency(Number(entryProductCategory.total_value))}
                className="text-center"
              />
            </div>

            {!hideButtons && (
              <div className="flex gap-x-8">
                <DeleteEntryProductCategoryModal
                  governmentAllocationId={governmentAllocationId}
                  entryProductCategoryId={entryProductCategory.id}
                  disabled={disabled}
                />

                <UpdateEntryProductCategoryModal
                  companyBranchId={companyBranchId}
                  governmentAllocationId={governmentAllocationId}
                  entryProductCategory={entryProductCategory}
                  governmentAllocationCurrencyRestricted={governmentAllocationCurrencyRestricted}
                />
              </div>
            )}
          </div>

          {entryProductCategory.entry_products.map((entryProduct) => (
            <Box className="py-3 px-3" key={entryProduct.id}>
              <div className="flex items-center justify-between border-s border-blue-800 px-3">
                <div className="flex items-center gap-x-2">
                  <FileBoxIcon strokeWidth={1.5} />

                  <p>{entryProduct.product.display_name}</p>
                </div>

                <ResumeItem
                  label="Valor limite"
                  value={formatCurrency(Number(entryProduct.total_value))}
                  className="text-center"
                />
              </div>
            </Box>
          ))}
        </Box>
      ))}
    </div>
  )
}
